const state = {
  registered: false,
  completed: false,
  economicModel: null,
  cos: null,
  namespaced: true,
};

const mutations = {
  SET_REGISTERED_RESOURCE: (state, registered) => {
    state.registered = registered;
  },
  SET_COMPLETED_RESOURCE: (state, completed) => {
    state.completed = completed;
  },
  SET_ECONOMIC_MODEL_RESOURCE: (state, economicModel) => {
    state.economicModel = economicModel;
  },
  SET_COS_RESOURCE: (state, cos) => {
    state.cos = cos;
  }
};

const getters = {
  registered: state => state.registered,
  completed: state => state.completed,
  economicModel: state => state.economicModel,
  cos: state => state.cos
};

const demo = {
  namespaced: true,
  state,
  getters,
  mutations
};

export default demo;
